var React = require('react');

function HSosaRegular (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1 0 0 -1 0 1540)"},React.createElement("path",{"fill":"currentColor","d":"M170 -186v624q0 12 9 20.5t20 8.5h227v-299q0 -60 33 -94q32 -34 85 -33h3q86 0 534 2v-229q0 -12 -8 -20.5t-20 -8.5h-541l-170 -172v172h-143q-11 0 -20 8.5t-9 20.5zM512 168v938q0 19 12 31t31 12h1280q18 0 30.5 -12.5t12.5 -30.5v-938q0 -17 -13 -30t-30 -13h-213\nv-256l-256 256h-811q-18 0 -30.5 12.5t-12.5 30.5z"})));
}

HSosaRegular.defaultProps = {"version":"1.1","viewBox":"-10 0 2058 2048"};

module.exports = HSosaRegular;

HSosaRegular.default = HSosaRegular;
